<template>
<div class="singUp-list">
  <div class="item" v-for="item of list" :key="item.id">
    <div class="left">
      <!-- <img v-lazy="`${item.user.avatar}?x-oss-process=image/resize,m_fill,w_128,h_128`"/> -->
      <img v-lazy="`${item.user.real_avatar!=='null' && item.user.real_avatar!=='' ? item.user.real_avatar:item.user.avatar}?x-oss-process=image/resize,m_fill,w_72,h_72`"/>
      <div class="info" @click="copyText(item.phoneNumber)">
        <!-- <div class="name">{{item.user.nickName}}</div> -->
        <div class="name">{{item.user.fullname !== '' && item.user.fullname !=='null' ? item.user.fullname : item.user.nickName}}</div>
        <div class="bottom"><span>{{item.phoneNumber}}</span>
         <img src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/%E5%A4%8D%E5%88%B6.svg"/></div>
      </div>
    </div>
    <span class="status" :style="{ color: item.status === 1 ? '#5FB878' : '#3C3C43' }">{{item.status === 1 ? '成功报名' : '已取消'}}</span>
  </div>
  <span class="desc">没有更多了</span>
</div>
</template>
<script>
import { Toast } from 'vant'
import { get } from '../../../utils/request'
import { get as getUser } from '../../../utils/token'
export default {
  data () {
    return {
      list: []
    }
  },
  // created () {
  //   this.getAllList()
  // },
  activated () {
    this.getAllList()
  },
  methods: {
    getAllList () {
      const { id } = this.$route.params
      const promise = get({
        url: `/call/joinList/${id}/${
          getUser('user').id
        }`
      })
      promise.then(res => {
        const {
          data: {
            code,
            detail
          }
        } = res
        if (Object.is(code, 200)) {
          this.list = detail
        }
      })
    },
    copyText (phoneNumber) {
      if (typeof document.execCommand !== 'function') {
        return
      }
      const dom = document.createElement('textarea')
      dom.value = phoneNumber
      dom.setAttribute('readonly', true)
      dom.setAttribute('style', 'display: blockwidth; 1px;height: 1px;')
      document.body.appendChild(dom)
      dom.select()
      const result = document.execCommand('copy')
      if (result) {
        document.body.removeChild(dom)
        Toast.success('号码复制成功')
        return
      }
      if (typeof document.createRange !== 'function') {
        return
      }
      const range = document.createRange()
      const div = document.createElement('div')
      div.innerHTML = phoneNumber
      div.setAttribute('style', 'display: height: 1px; fontSize: 1px; overflow: hidden')
      document.appendChild(div)
      range.selectNode(div)
      const selection = window.getSelection()
      if (selection.rangeCount > 0) {
        selection.removeAllRanges()
      }
      selection.addRange(range)
      document.execCommand('copy')
      document.body.removeChild(div)
      Toast.success('号码复制成功')
    }
  }
}
</script>
<style lang="scss" scoped>
.singUp-list {
  padding: 16px;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  box-sizing: border-box;
  .item {
    width: 100%;
    height:68px;
    box-sizing: border-box;
    background:rgba(255,255,255,1);
    border-radius:8px;
    padding: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      height: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      img {
        width:36px;
        height:36px;
        border-radius: 50%;
        margin-right: 6px;
      }
      .info {
        display: flex;
        height: 100%;
        flex-direction: column;
        align-items: flex-start;
        .name {
          font-size:16px;
          font-family:PingFangSC-Semibold,PingFang SC;
          font-weight:600;
          color:rgba(51,51,51,1);
          line-height:16px;
          margin-bottom: 7px;
        }
        .bottom {
          font-size:11px;
          font-family:PingFangSC-Regular,PingFang SC;
          font-weight:400;
          color:rgba(60,60,67,0.6);
          line-height:12px;
          img {
            width: 12px;
            height: 12px;
            margin-left: 8px;
            border-radius: 0;
          }
        }
      }
    }
    .status {
      height:20px;
      font-size:14px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(60,60,67,0.6);
      line-height:20px;
    }
  }
  .desc {
    width: 100%;
    text-align: center;
    font-size:12px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(170,178,183,1);
    line-height:17px;
    display: block;
    margin-top: 37px;
  }
}
</style>
